"use client";

import { MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function EmpowerYourMovement() {
  const exhaustPuffs = [{
    text: "gain!",
    delay: "0s",
    top: "20%",
    left: "-8%"
  }, {
    text: "lift!",
    delay: "0.5s",
    top: "8%",
    left: "-14%"
  }, {
    text: "move!",
    delay: "1s",
    top: "32%",
    left: "-18%"
  }];
  return <section data-section-id="1121" id="empower-your-movement" className="relative overflow-hidden bg-background text-foreground pt-32 pb-40 md:pt-40 md:pb-48" style={{
    fontFamily: "var(--font-default)"
  }}>
      {}
      <svg aria-hidden="true" className="pointer-events-none absolute -bottom-3 left-0 right-0 w-full h-8 z-20" viewBox="0 0 1200 32" preserveAspectRatio="none">
        <path d="M0,16 L1200,12 L1200,28 L0,24 Z" fill="var(--background)" stroke="var(--foreground)" strokeWidth="2" />
      </svg>

      {}
      <svg aria-hidden="true" className="pointer-events-none absolute bottom-0 left-0 w-full h-40 z-10 opacity-80" viewBox="0 0 1200 200" fill="none" preserveAspectRatio="none">
        <path d="M 80 40 C 200 80, 320 20, 440 80 S 680 160, 820 100 S 1080 40, 1180 140" stroke="var(--foreground)" strokeWidth="3" strokeDasharray="8 4" strokeLinecap="round" />
      </svg>

      <div className="relative mx-auto max-w-[1360px] px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          {}
          <div className="lg:col-span-7 relative z-10">
            {}
            <div className="inline-block mb-8 px-4 py-2 border-2 border-foreground bg-accent -rotate-2" style={{
            fontFamily: "var(--font-mono)"
          }}>
              <span className="text-xs md:text-sm font-bold tracking-[0.18em] uppercase text-foreground">
                NO. 01 / COACH KIRA FIT
              </span>
            </div>

            {}
            <h1 className="text-foreground mb-8 relative font-default" style={{
            fontSize: "clamp(3.5rem, 9vw, 8.5rem)",
            lineHeight: "0.92",
            letterSpacing: "-0.02em",
            fontWeight: 800
          }}>
              Precision training for{" "}
              <span className="relative inline-block">
                <span className="relative z-10">RESULTS</span>
                <svg aria-hidden="true" className="absolute -inset-x-4 -inset-y-3 w-[calc(100%+2rem)] h-[calc(100%+1.5rem)] pointer-events-none z-0" viewBox="0 0 300 120" fill="none" preserveAspectRatio="none">
                  <path d="M 30 60 C 20 20, 100 8, 160 12 C 230 16, 285 30, 290 65 C 295 100, 220 112, 140 108 C 70 104, 18 92, 25 60" stroke="var(--primary)" strokeWidth="6" strokeLinecap="round" fill="none" style={{
                  strokeDasharray: 800,
                  strokeDashoffset: 800,
                  animation: "drawCircle 900ms ease-out 0.3s forwards"
                }} />
                </svg>
              </span>
            </h1>

            {}
            <p className="text-foreground/80 mb-10 max-w-[38ch] font-default" style={{
            fontSize: "clamp(1.125rem, 1.3vw, 1.375rem)",
            fontWeight: 400,
            lineHeight: 1.55
          }}>
              Customized fitness coaching, strength training, and sustainable health habits for your peak performance.
            </p>

            {}
            <div className="flex flex-wrap gap-4 items-center">
              <Link to="/TheTrainingPathPage">
                <Button className="bg-primary text-primary-foreground border-[3px] border-foreground px-9 py-7 uppercase tracking-wide font-extrabold text-base hover:bg-primary hover:-translate-x-[2px] hover:-translate-y-[2px] transition-transform" style={{
                boxShadow: "6px 6px 0 var(--foreground)",
                fontFamily: "var(--font-default)"
              }}>
                  View Programs
                </Button>
              </Link>
              <Link to="/StartYourJourneyPage">
                <Button className="bg-secondary text-secondary-foreground border-[3px] border-foreground px-9 py-7 uppercase tracking-wide font-extrabold text-base hover:bg-secondary hover:-translate-x-[2px] hover:-translate-y-[2px] transition-transform" style={{
                boxShadow: "6px 6px 0 var(--foreground)",
                fontFamily: "var(--font-default)"
              }}>
                  Start Coaching
                </Button>
              </Link>
            </div>
          </div>

          {}
          <div className="lg:col-span-5 relative">
            <div className="relative aspect-[4/5] lg:aspect-square overflow-hidden rounded-lg shadow-lg border-2 border-foreground">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/coach_kira_training_session.webp" alt="Coach Kira training session" className="w-full h-full object-cover" loading="lazy" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/coach_kira_training_session.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1700144/img/coach_kira_training_session.webp-wvc-sizes" />
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes drawCircle {
          to { stroke-dashoffset: 0; }
        }
        @keyframes truckBob {
          0%, 100% { transform: translateY(-6px); }
          50% { transform: translateY(6px); }
        }
        @keyframes wheelSpin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @keyframes puffFade {
          0%, 100% { opacity: 0; transform: translateY(0) rotate(-8deg); }
          50% { opacity: 1; transform: translateY(-10px) rotate(-8deg); }
        }
        @keyframes stickerPulse {
          0%, 100% { transform: rotate(-8deg) scale(1); }
          50% { transform: rotate(-8deg) scale(1.03); }
        }
      `}</style>
    </section>;
}